import { render, staticRenderFns } from "./ProjectListSection.vue?vue&type=template&id=38de0b7d&scoped=true&"
import script from "./ProjectListSection.vue?vue&type=script&lang=js&"
export * from "./ProjectListSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListSection.vue?vue&type=style&index=0&id=38de0b7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de0b7d",
  null
  
)

export default component.exports